import actionTypes from '../actions/types';

export const INITIAL_STATE = {
  markets: [],
};

export const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.SET_MARKETS_DATA:
      return { ...state, markets: [...action.data] };
    default:
      return state;
  }
};
